import { createSlice } from "@reduxjs/toolkit"
import { DEFAULT_REQUEST_FILTER } from "../databucket"

const initialState = {
    // Landing view for the Requests list. "Active" is a COMPOSITE the backend
    // expands to Open + In Progress + On Hold (ACTIVE_REQUEST_STATUSES in
    // Backend/GraphQL/Queries/getAllOrders.js). This initial state is what
    // actually decides the default — Requests.jsx only falls back to
    // DEFAULT_REQUEST_FILTER when `filters.filter` is empty, which it never is.
    filters: { filter: DEFAULT_REQUEST_FILTER },
    pages: 1,
    colorSchema: 'blue',
    layout: 'vertical',
    layoutWidth: 'fixed',
    layoutPos: 'fluid',
    topbarTheme: 'light',
    layoutSized: 'lg',
    layoutStyling: 'default',
    layoutSidebarStyle: 'dark',
    email: '',
    password: '',
    activeMenuValue: "Employees",
    loginDetails: [], // stores list of registered users
    currentUser: null,
    isValidUser: true,
}

const taskSlice = createSlice({
    name: "task",
    initialState,
    reducers: {
        setFilters: (state, action)=>{
            state.filters = action.payload;
        },
        setPages : (state, action)=>{
            state.pages = action.payload;
        },
        resetFilters: (state)=>{
            state.filters = { filter: DEFAULT_REQUEST_FILTER };
            state.pages = 1;
        },
        setCredentials: (state, action) => {
            const {email, password } = action.payload;
            state.email = email;
            state.password = password;
          },
          clearCredentials: (state) => {
            state.email = null;
            state.password = null;
          },
          setLayoutConfig: (state, action) => {
            return { ...state, ...action.payload };
          },
          resetLayoutConfig: () => initialState,

          setActiveMenuValue: (state, action) => {
            state.activeMenuValue = action.payload;
          },
          registerUser(state, action) {
            const { email, password } = action.payload;
            const existingUser = state.loginDetails.find(user => user.email === email);
            if (!existingUser) {
              state.loginDetails.push({ email, password });
              state.currentUser = { email };
              state.isValidUser = true;
            } else {
              state.isValidUser = false;
            }
          },
          resetUserValidation(state) {
            state.isValidUser = true;
          }
    }
});

export const {
    setFilters,
    setPages,
    resetFilters,
    setCredentials,
    clearCredentials,
    setLayoutConfig,
    resetLayoutConfig,
    setActiveMenuValue,
    registerUser,
    resetUserValidation
 } = taskSlice.actions;
export default taskSlice.reducer;